/**
 * Company size buckets. `id` is a representative integer stored in the
 * `companies.size` smallint column (the bucket's lower bound).
 */
export const sizes = [
  { id: 1, name: "1-15 employees" },
  { id: 16, name: "16-100 employees" },
  { id: 101, name: "101-500 employees" },
  { id: 501, name: "501-1000 employees" },
  { id: 1001, name: "1001+ employees" },
];

/**
 * Coerces an arbitrary imported headcount into one of the sizes above, which is
 * the only set the company forms and filters can render.
 */
export const mapSizeToCategory = (size: number): 1 | 16 | 101 | 501 | 1001 => {
  if (size <= 15) return 1;
  if (size <= 100) return 16;
  if (size <= 500) return 101;
  if (size <= 1000) return 501;
  return 1001;
};
